import React from "react";
import { Outlet } from "react-router-dom";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav />
      <main><Outlet /></main>
      <PublicFooter />
    </div>
  );
}
